<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <el-dialog
    :title="showTitle"
    :visible="show"
    width="60%"
    :close-on-click-modal="false"
    :before-close="closeWindow"
    class="dialog_container"
  >
    <el-row :gutter="10" class="dialogBtns">
      <el-button
        style="margin: 0 5%"
        :type="display === 0 ? 'primary' : 'info'"
        @click="sendMsg"
        >工单信息
      </el-button>
      <el-button
        v-show="btnActive"
        :type="display === 3 ? 'primary' : 'info'"
        @click="callbackingMag"
        :disabled="serverObj.id === undefined || serverObj.id === ''"
      >
        处理中回访信息
      </el-button>
      <el-button
        style="margin: 0 5%"
        :type="display === 1 ? 'primary' : 'info'"
        @click="disposeMsg"
        :disabled="serverObj.id === undefined || serverObj.id === ''"
        >处理信息
      </el-button>

      <el-button
        v-if="!dealFlag"
        v-show="btnActive"
        style="margin: 0 5%"
        :type="display === 2 ? 'primary' : 'info'"
        @click="callbackMag"
        :disabled="serverObj.id === undefined || serverObj.id === ''"
        >回访信息
      </el-button>
      <el-button
        v-if="!dealFlag"
        v-show="btnActive"
        style="margin: 0 5%"
        :type="display === 4 ? 'primary' : 'info'"
        @click="InfoMag"
        :disabled="serverObj.id === undefined || serverObj.id === ''"
        >补充资料
      </el-button>
    </el-row>
    <el-form :model="serverState" ref="serverState" :rules="rules">
      <el-form-item
        label="工单状态："
        prop="states"
        v-if="showTitle == '工单补录'"
      >
        <el-select v-model="serverState.states">
          <el-option label="待回访" :value="2"></el-option>
          <el-option label="已完成" :value="3"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <CallbackVisitDialogss
      ref="CallbackVisitDialog"
      @updateList="getDataList"
      @alldata="alldata"
      :orderInfo="serverObj"
      :showTitle="showTitle"
      v-show="display === 0"
    ></CallbackVisitDialogss>
    <!-- 处理信息 -->
    <div v-show="display === 1">
      <div style="height: 12px"></div>
      <el-form
        label-width="180px"
        ref="form"
        :disabled="showTitle == '查看'"
        :model="serverObj"
      >
        <el-form-item label="APP用户反馈语音评价：">
          <el-input v-model="serverObj.evaluate"></el-input>
        </el-form-item>
        <audio
          controls="controls"
          preload="auto"
          class="audioActive"
          :src="serverObj.estimateRecord"
        ></audio>
        <form ref="clearPaths" style="display: inline-block">
          <input
            type="file"
            @change="audiohttpD"
            class="audios"
            accept="audio/*"
            :disabled="showTitle == '查看'"
          />
        </form>
        <!-- <el-upload
                    ref="replaceUploader"
                    class='audiofile'
                    :action="actionUrl"
                    :limit="1"
                    :file-list="fileList"
                    :on-success="
                                    (file, fileList) => {
                                    handleReplaceAvatarSuccess(file, fileList)
                                    }
                                "
                    :on-exceed="handleExceed"
                    :beforeUpload="beforeAvatarUpload2">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload> -->
        <!-- <el-form-item label="第二次语音评价：">
                    <el-input
                        v-model="serverObj.estimate"
                    ></el-input>
                </el-form-item>
                <audio
                    controls="controls"
                    preload="auto"
                    class="audioActive"
                    :src="serverObj.estimate"
                ></audio> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间：">
              <el-date-picker
                v-model="serverObj.timeStart"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间：">
              <el-date-picker
                v-model="serverObj.timeEnd"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="服务内容：">
          <el-input type="textarea" v-model="serverObj.visitContent"></el-input>
        </el-form-item>
        <el-form-item label="工作图片：">
          <el-row :gutter="10">
            <el-col :span="6">
              <!-- <img
                                v-if="serverObj.picStart"
                                :src="serverObj.picStart"
                                alt="工作开始图片"
                            /> -->
              <el-upload
                :action="actionUrl"
                :show-file-list="false"
                :on-success="
                  (file, fileList) => {
                    handleAvatarSuccess(file, fileList)
                  }
                "
                :before-upload="beforeAvatarUpload"
                accept=".jpg,.png"
              >
                <div class="avatar" v-if="serverObj.picStart">
                  <img :src="serverObj.picStart" />
                </div>
                <div v-else>
                  <i
                    class="el-icon-plus avatar_uploader avatar-uploader-icon"
                  ></i>
                </div>
              </el-upload>
              <div class="workstart">工作开始</div>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="6">
              <!-- <img
                                v-if="serverObj.picFinished"
                                :src="serverObj.picFinished"
                                alt="工作结束图片"
                            /> -->
              <el-upload
                :action="actionUrl"
                :show-file-list="false"
                :on-success="
                  (file, fileList) => {
                    handleAvatarSuccess1(file, fileList, 'add')
                  }
                "
                :before-upload="beforeAvatarUpload1"
                accept=".jpg,.png"
              >
                <div class="avatar" v-if="serverObj.picFinished">
                  <img :src="serverObj.picFinished" />
                </div>
                <div v-else>
                  <i
                    class="el-icon-plus avatar_uploader avatar-uploader-icon"
                  ></i>
                </div>
              </el-upload>
              <div class="workstart">工作结束</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="工作视频：">
          <div class="uploadBox">
            <div class="uploadFlex">
              <video
                id="myvideo1"
                :src="serverObj.videoUrl"
                style="height: 200px; width: 300px; margin: 0 10px"
                ref="videoId"
                autoplay="true"
                controls
                muted
              ></video>
              <input
                type="file"
                @change="videohttp"
                accept="video/*"
                :disabled="showTitle == '查看'"
              />
            </div>
          </div>
        </el-form-item>
        <!--                <el-divider></el-divider>-->
        <!--                <div style="height: 12px; margin-top: 30px; color: #169bd5">-->
        <!--                    是否合格-->
        <!--                </div>-->
        <!-- <el-divider></el-divider>
        <el-form-item label="状态：" prop="active">
          <el-radio-group
              v-model="serverObj.active"
              @change="disqualificationFun"
          >
            <el-radio label="合格"></el-radio>
            <el-radio label="不合格"></el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
    </div>
    <!--  处理中回访信息 -->
    <div v-show="display === 3">
      <div style="height: 12px; margin-top: 30px; color: #169bd5">
        处理中回访信息
      </div>
      <el-divider></el-divider>
      <el-form
        label-width="180px"
        ref="form"
        :model="serverObj"
        :disabled="showTitle == '查看'"
      >
        <el-form-item label="客户名称：">
          <el-col :span="10">
            <el-input v-model="serverObj.customerName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式：">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input v-model="serverObj.customerphone"></el-input>
            </el-col>
            <el-col :span="1">
              <i
                class="el-icon-phone"
                title="电话"
                style="cursor: pointer"
                @click="callPhone1(serverObj.customerphone, '1')"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="服务人员是否准时：">
          <el-radio-group v-model="serverObj.isOnTime">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务态度是否良好：">
          <el-radio-group v-model="serverObj.isGood">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务时间是否符合规范：">
          <el-radio-group v-model="serverObj.isStandard">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务人员着装是否整洁：">
          <el-radio-group v-model="serverObj.isTidy">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拨打状态：" prop="dialingStatus">
          <el-radio-group v-model="serverObj.dialingStatus">
            <el-radio label="0">正常接听</el-radio>
            <el-radio label="1">无人接听</el-radio>
            <el-radio label="2">关机</el-radio>
            <el-radio label="3">停机</el-radio>
            <el-radio label="4">空号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务对象评价：">
          <el-input
            type="textarea"
            v-model="serverObj.ojectEvaluation"
          ></el-input>
        </el-form-item>
        <audio
          controls="controls"
          preload="auto"
          class="audioActive"
          :src="serverObj.estimateVoiceRecord"
        ></audio>
        <form ref="clearPaths" style="display: inline-block">
          <input
            type="file"
            @change="audiohttp"
            class="audios"
            accept="audio/*"
            :disabled="showTitle == '查看'"
          />
        </form>
        <el-form-item label="回访结果：">
          <el-radio-group v-model="serverObj.results">
            <el-radio label="0">合格</el-radio>
            <el-radio label="1">不合格</el-radio>
            <el-radio label="2">作废</el-radio>
            <el-radio label="3">虚假工单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="理由：">
          <el-input type="textarea" v-model="serverObj.reason"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 回访信息 -->
    <div v-show="display === 2" v-if="!dealFlag">
      <div style="height: 12px; margin-top: 30px; color: #169bd5">回访信息</div>
      <el-divider></el-divider>
      <el-form
        label-width="180px"
        ref="form"
        :model="serverObj"
        :disabled="showTitle == '查看'"
      >
        <el-form-item label="客户名称：">
          <el-col :span="10">
            <el-input v-model="serverObj.customerName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式：">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input v-model="serverObj.customerphone"></el-input>
            </el-col>
            <el-col :span="1">
              <i
                class="el-icon-phone"
                title="电话"
                style="cursor: pointer"
                @click="callPhone2(serverObj.customerphone, '1')"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <audio
            controls="controls"
            style="margin-left: 0"
            preload="auto"
            class="audioActive"
            :src="serverObj.recVisit"
          ></audio>
          <form ref="clearPaths" style="display: inline-block">
            <input
              type="file"
              @change="audiohttp1"
              class="audios"
              accept="audio/*"
              :disabled="showTitle == '查看'"
            />
          </form>
        </el-form-item>
        <el-form-item label="图片：">
          <el-upload
            :action="actionUrl"
            :show-file-list="false"
            :on-success="
              (file, fileList) => {
                handleAvatarSuccess2(file, fileList)
              }
            "
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png"
          >
            <div class="avatar" v-if="serverObj.pictureVisit">
              <img
                :src="serverObj.pictureVisit"
                style="width: 178px; height: 178px"
              />
            </div>
            <div v-else>
              <i
                class="el-icon-plus avatar_uploader avatar-uploader-icon"
                style="border: 1px solid #ddd"
              ></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否通过App处理工单：" prop="fromApps">
          <el-radio-group v-model="serverObj.fromApps">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传图片是否符合规范：" prop="rightPic">
          <el-radio-group v-model="serverObj.rightPic">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务时间是否符合规范：" prop="rightTime">
          <el-radio-group v-model="serverObj.rightTime">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否上传语音评价：" prop="rightEstimateRecord">
          <el-radio-group v-model="serverObj.rightEstimateRecord">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拨打状态：" prop="dialStatus">
          <el-radio-group v-model="serverObj.dialStatus">
            <el-radio label="0">正常接听</el-radio>
            <el-radio label="1">无人接听</el-radio>
            <el-radio label="2">关机</el-radio>
            <el-radio label="3">停机</el-radio>
            <el-radio label="4">空号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务对象评价：">
          <el-input type="textarea" v-model="serverObj.estimate"></el-input>
        </el-form-item>
        <el-form-item label="服务企业（组织）评价：">
          <el-input
            type="textarea"
            v-model="serverObj.jiamengEstimate"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户满意度：">
          <el-select v-model="serverObj.estimateLevel" placeholder="请选择">
            <el-option
              v-for="item in estimateLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否上门：">
          <el-radio-group v-model="serverObj.visited">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="回访结果：">
          <el-radio-group v-model="serverObj.visitResults">
            <el-radio label="0">合格</el-radio>
            <el-radio label="1">不合格</el-radio>
            <el-radio label="2">作废</el-radio>
            <el-radio label="3">虚假工单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="理由：">
          <el-input type="textarea" v-model="serverObj.visitReason"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 补充资料 -->
    <div v-show="display === 4">
      <div style="height: 12px; margin-top: 30px; color: #169bd5">补充资料</div>
      <el-divider></el-divider>
      <el-form
        label-width="180px"
        ref="form"
        :disabled="showTitle == '查看'"
        :model="serverinfoObj"
      >
        <el-form-item label="上传录音：" prop="suppleRecord">
          <audio
            controls="controls"
            style="margin-left: 0"
            preload="auto"
            class="audioActive"
            :src="serverinfoObj.suppleRecord"
          ></audio>
          <form ref="clearPaths" style="display: inline-block">
            <input
              type="file"
              @change="audiohttp2"
              class="audios"
              ref="clearPath"
              accept="audio/*"
              :disabled="showTitle == '查看'"
            />
          </form>
        </el-form-item>
        <el-form-item label="上传视频：" prop="suppleVideo">
          <div class="uploadBox">
            <div class="uploadFlex">
              <video
                id="myvideo1"
                :src="serverinfoObj.suppleVideo"
                style="height: 200px; width: 300px; margin: 0 10px"
                ref="videoId"
                autoplay="true"
                controls
                muted
              ></video>
              <form ref="clearPaths" style="display: inline-block">
                <input
                  type="file"
                  accept="video/*"
                  ref="clearPath"
                  @change="videosuperhttp"
                  :disabled="showTitle == '查看'"
                />
              </form>
              <!-- <el-upload
                                class="avatar-uploader"
                                :action="actionUrl1"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess4"
                                :before-upload="beforeAvatarUpload"
                            >
                                <i
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上传图片：" prop="supplePic">
          <el-upload
            :action="actionUrl"
            :file-list="fileList"
            list-type="picture-card"
            :limit="10"
            :on-success="
              (file, fileList) => {
                handleAvatarSuccess3(file, fileList)
              }
            "
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            @click="masterFileMax"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="btn">
      <div>
        <el-button type="primary" @click="send" v-if="showTitle !== '查看'"
          >保存
        </el-button>
        <!-- <el-button
                    @click="payOut"
                    type="primary"
                    v-if="showTitle !== '查看'"
                    >派发
                </el-button> -->
        <el-button @click="closeWindow" type="info">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import request from "@/utils/request.js"
import {
  uploadOnlineStudyVideo,
  uploadOnlineStudyAudio,
} from "@/api/partyReportedcopyhttp"
import CustomerList from "../component/customerList.vue"
import ChanPinList from "../component/chanPinList.vue"
import ServeStation from "../component/serveStation.vue"
import CallbackVisitDialogss from "../component/CallbackVisitDialogss"
import exportVue from "@/utils/exportVue"
import baseURL from "@/api/baseURL"
export default {
  components: {
    CustomerList,
    ChanPinList,
    ServeStation,
    CallbackVisitDialogss,
  },
  name: "visitDialogs",

  // props: {
  //     showVisit: {
  //         type: Boolean,
  //         default: false,
  //     },
  //     showTitle: {
  //         type: String,
  //         default: "",
  //     },
  //     orderInfo: {
  //         type: Object,
  //         default: {},
  //     },
  //     dealFlag: {
  //         type: Boolean,
  //         default: false,
  //     },
  //     datas: {
  //         type: Array,
  //         default: "",
  //     },
  // },
  props: [
    "showVisit",
    "callback",
    "showTitle",
    "orderInfo",
    "recordObj",
    "dealFlag",
    "datas",
  ],
  data() {
    return {
      fileList: [],
      checkList: [],
      showCard: false,
      volunteer: false,
      franchisee: false,
      otherServePerson: false,
      qtlxfs: false,
      imageUrl: "",
      radio: "",
      actionUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      actionUrl1:
        baseURL + "/jjyl/controller/uploadController/info/uploadVideo",
      showAddStatus: false,
      replaceList: [],
      showChanpin: false,
      showStation: false,
      showSallianceBusiness: false,
      jiamengTemp: "",
      showServeName: false,
      showServeName1: false,
      serveName1: "",
      showVolunteer: false,
      franchiseename: "",
      tempJiameng: "",
      rules: {
        customerName: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "input",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: "blur",
          },
        ],
        contactrName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        taocanleixing: [
          {
            required: true,
            message: "请输入套餐类型",
            trigger: "blur",
          },
        ],
        states: [
          {
            required: true,
            message: "请选择工单状态",
            trigger: "blur",
          },
        ],

        servestationName: [
          { required: true, message: "该项必填", trigger: "input" },
        ],
      },
      serverState: {},
      // 套餐类型列表
      ensureList: [],
      serviceTypeList: [],
      serverObj: {
        servestationName: "",
        period: "",
        estimateRecord: "",
        estimateVoiceRecord: "",
      },
      serverinfoObj: {
        supplePic: [],
        suppleVideo: "",
        suppleRecord: "",
      },
      estimateLevelList: [
        { value: "0", label: "未评价" },
        { value: "1", label: "没有服务" },
        { value: "2", label: "不满意" },
        { value: "3", label: "服务一般" },
        { value: "4", label: "基本满意" },
        { value: "5", label: "非常满意" },
      ],
      display: 0,
      btnActive: true,
      allianceBusiness: {},
      jmTableData: [],
      serveName: "",
      serveNameTableData: [],
      serveName1TableData: [],
      volunteerName: "",
      volunteerTableData: [],
      serveNameTemp: "",
      volunteerTemp: "",
      // 选择的insert
      servePersonData: undefined,
      totalCount: 0,
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      // 套餐类型应当选择的服务数量
      serviceNumber: 0,
      infoId: "", //工单视频 图片返回的id
    }
  },
  computed: {
    show() {
      return this.showVisit
    },
  },
  watch: {
    orderInfo(newVal) {
      if (newVal) {
        // 设置站点类型
        newVal.statType = "0"
        this.serverObj = JSON.parse(JSON.stringify(newVal))
        this.serverState.states = this.serverObj.states
        // this.infoId = this.serverObj.infoId
        if (this.serverObj.visited) {
          // this.serverObj.visited = String(this.serverObj.visited)
        }
        if (this.serverObj.estimateRecord == null) {
          this.serverObj.estimateRecord = ""
        }
        if (this.serverObj.estimateVoiceRecord == null) {
          this.serverObj.estimateVoiceRecord = ""
        }
        if (this.serverObj.recVisit == null) {
          this.serverObj.recVisit = ""
        }
        this.$refs.clearPaths && this.$refs.clearPaths.reset()
        // 如果存在加盟商
        if (this.serverObj.jiamengId) {
          this.serverObj.franchisee = "是"
          this.franchisee = true
        } else {
          this.serverObj.franchisee = "否"
          this.franchisee = false
        }
        // console.log(this.serverObj.otherservePersonName,'this.serverObj.otherservePersonName')
        // 如果存在从属服务人员
        if (this.serverObj.otherservePersonName != "") {
          this.aa = "是"
          this.serverObj.otherServePerson = "是"
          this.otherServePerson = true
        } else {
          this.aa = "否"
          this.serverObj.otherServePerson = "否"
          this.otherServePerson = false
        }
        // 如果存在志愿者
        if (this.serverObj.otherReturnContent != "") {
          this.bb = "是"
          this.serverObj.volunteer = "是"
          this.volunteer = true
        } else {
          this.bb = "否"
          this.serverObj.volunteer = "否"
          this.volunteer = false
        }
        // 处理是否需要其他联系方式
        if (this.serverObj.familyPhone) {
          this.serverObj.otherTelephone = "1"
          this.qtlxfs = true
        } else {
          this.serverObj.otherTelephone = "2"
          this.qtlxfs = false
        }
      }
    },
    recordObj(val) {
      if (val) {
        this.fileList = []
        this.serverinfoObj = JSON.parse(JSON.stringify(val))
        this.infoId = this.serverinfoObj.id
        if (this.serverinfoObj.supplePic) {
          this.serverinfoObj.supplePic = this.serverinfoObj.supplePic.split(",")
          this.fileList = this.serverinfoObj.supplePic.map((item) => {
            return {
              url: item,
            }
          })
        }
      }
    },
  },
  async created() {
    this.baseUrl =
      baseURL + "/jjyl/controller/uploadController/info/uploadPhoto"
    this.serveproductName = []
    this.serverObj.servetypename = ""

    await this.getDataList()

    await this.getServiceTypeList()
    if (this.showTitle == "新增") {
      await this.getProjectList().then((res) => {
        this.tableProject = res
      })
    }
    // 获取类别
    this.$http
      .request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 1000,
          states: "1",
        },
      })
      .then((res) => {
        if (res.code === 200) {
          res.content.list.forEach((item) => {
            if (item.status == 1) {
              this.serviceTypeList.push(item)
            }
          })
        }
      })
  },
  created() {
    this.getDataList()
  },
  methods: {
    alldata(data) {
      this.serverObj = data
    },
    // 点击处理
    dealSend() {
      this.$post("/jjyl/servicePgd/info/Handle", {
        ...this.serverObj,
        states: 2,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("处理成功")
          this.$emit("updateList")
          this.closeWindow()
        } else {
          this.$message.error("处理失败")
          this.$emit("updateList")
          this.closeWindow()
        }
      })
    },
    // 套餐类型选择发生改变
    onEnsureChange(val) {
      if (val) {
        // 获取需要选择服务的数量
        for (let i = 0; i < this.ensureList.length; i++) {
          if (this.ensureList[i].id == val) {
            this.serviceNumber = this.ensureList[i].serviceNumber
            return
          }
        }
      }
    },
    // 获取套餐类型列表
    getEnsureList() {
      request({
        url: "/jjyl/admin/meal/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          customerId: this.serverObj.customer,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.ensureList = res.content.list || []
          this.ensureList.forEach((item) => {
            item.id = item.id + ""
          })
        }
      })
    },
    //客户姓名回显
    sendCustomerName(data) {
      this.serverObj = {}
      this.serveproductName = []
      this.$set(this.serverObj, "dataId", data.dataId)
      this.$set(this.serverObj, "customerName", data.customerName)
      this.$set(this.serverObj, "customer", data.customer)
      this.getEnsureList()
    },
    //服务项目回显
    productNames(data) {
      if (Array.isArray(data) && data.length > 0) {
        let serveproductName = ""
        let serveProduct = ""
        let produce = ""
        data.forEach((item, index) => {
          if (index === data.length - 1) {
            serveproductName = serveproductName + item.productname
            serveProduct = serveProduct + item.id
            produce = produce + item.produce
          } else {
            serveproductName = serveproductName + item.productname + ","
            serveProduct = serveProduct + item.id + ","
            produce = produce + item.produce + ","
          }
        })
        this.$set(this.serverObj, "serveproductName", serveproductName)
        this.$set(this.serverObj, "serveProduct", serveProduct)
        this.$set(this.serverObj, "produce", produce)
      }
    },
    // 显示机构弹框
    inputClickStation() {
      if (this.showTitle === "查看") return
      this.showStation = true
      this.$nextTick(() => {
        this.$refs.ServeStation && this.$refs.ServeStation.getDataList()
      })
    },
    // 机构弹框内点击保存
    sendServestation(data) {
      this.$set(this.serverObj, "servestationName", data.statname)
      this.$set(this.serverObj, "servestationId", data.id)
    },
    getProjectList(ids) {
      let self = this
      let params = {}
      let url = ""
      if (this.showTitle == "工单补录") {
        params = {
          pageNo: 1,
          pageSize: 99,
          status: "1",
        }
        url = "/jjyl/admin/product/info/findList"
      } else {
        params = {
          pageNo: 1,
          pageSize: 99,
          // status: "1",
          ids: ids,
        }
        url = "/jjyl/admin/product/info/findByIds"
      }
      return new Promise((resolve, reject) => {
        request({
          url,
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code === 200 && res.content) {
            if (self.showTitle == "新增") {
              let tableProject = res.content.list || []
              resolve(tableProject)
            } else {
              let tableProject = res.content || []
              resolve(tableProject)
            }
          } else {
            resolve([])
          }
        })
      }).catch((err) => {})
    },
    // 选择服务项目
    inputClickChanPin() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servetypename) {
        this.$message.error("请先选择服务种类")
        return
      }
      this.showChanpin = true
      this.$refs.ChanPinList && this.$refs.ChanPinList.getDataList()
    },
    // 获取服务种类
    getServiceTypeList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          typeLevel: 0,
          pageSize: 1000,
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serviceTypeList = res.content || []
        } else {
          this.$message.error("获取服务种类失败")
        }
      })
    },
    // 保存选中的加盟商
    getJMS(val) {
      this.jiamengTemp = val
      this.getJMSList()
    },
    //加盟商表格分页
    jmSizeChange(val) {
      this.query.pageSize = val
      this.getJMSList()
    },
    // 加盟商列表页数改变
    jmCurrentChange(val) {
      this.query.pageNo = val
    },
    // 加盟商弹框点击保存
    jmSend() {
      if (!this.jiamengTemp) {
        this.$message.error("请选择一个加盟商")
        return
      }
      this.showSallianceBusiness = false
      this.$set(
        this.serverObj,
        "servestationNameJMS",
        this.jiamengTemp.franchiseename
      )
      this.$set(this.serverObj, "servestationIdJMS", this.jiamengTemp.id)
    },
    // 获取加盟商列表
    getJMSList() {
      request({
        url: "/jjyl/admin/franchisee/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          serviceStationId: this.serverObj.serviceStationId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.jmTableData = res.content.list || []
          this.totalCount = res.content.count || 0
          this.$set(
            this.serverObj,
            "franchisee",
            this.totalCount > 0 ? "是" : "否"
          )
        } else {
          this.$message.info("当前机构下暂无加盟商")
        }
      })
    },
    // 显示加盟商选择弹框
    servestationNameFn() {
      if (this.showTitle === "查看") return
      this.showSallianceBusiness = true
      this.getJMSList()
    },
    // 关闭加盟商弹框
    onJMSClose() {
      this.showSallianceBusiness = false
      this.franchiseename = ""
      this.tempJiameng = ""
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    onVolunteerClose() {
      // 志愿者弹框关闭
      this.showVolunteer = false
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
      this.volunteerTemp = []
    },
    // 志愿者
    voluteerNameFn() {
      if (this.showTitle === "查看") return
      this.showVolunteer = true
      this.getVoluteerList()
    },
    // 获取志愿者
    getVoluteerList() {
      request({
        url: "/jjyl/admin/volunteerArchive/info/list",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          gridId: this.$store.state.info.gridId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.volunteerTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取志愿者失败")
        }
      })
    },
    // 从属服务人员
    serveNameFn() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servestationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName = true
      this.getServeNameDataList()
    },
    // 显示服务人员弹框
    serveName1Fn() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servestationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName1 = true
      this.getServeName1DataList()
    },
    // 服务人员页码切换
    serveName1SizeChange(val) {
      this.query.pageSize = val
      this.getServeName1DataList()
    },
    serveName1CurrentChange(val) {
      this.query.pageNo = val
      this.getServeName1DataList()
    },
    // 从属服务人员表格分页
    serveNameSizeChange(val) {
      this.query.pageSize = val
      this.getServeNameDataList()
    },
    serveNameCurrentChange(val) {
      this.query.pageNo = val
      this.getServeNameDataList()
    },
    //服务人员的表格获取
    getServeName1DataList() {
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          // 获取当前机构下面的服务人员
          serviceStationName: this.serverObj.servestationName,
          servePersonName: this.serveName1,
          serviceStationId: this.serverObj.serviceStationId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveName1TableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.serveName1TableData = []
          this.totalCount = 0
          this.$message.error("该机构下暂无服务人员")
        }
      })
    },
    // 从属服务人员的表格获取
    getServeNameDataList() {
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          // 获取当前机构下面的服务人员
          serviceStationName: this.serverObj.servestationName,
          servePersonName: this.serveName,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveNameTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.serveNameTableData = []
          this.totalCount = 0
          this.$message.error("获取服务人员失败")
        }
      })
    },
    // 服务人员点击保存
    serveName1Send() {
      this.$set(this.serverObj, "servePersonName", this.servePersonData.name)
      this.$set(this.serverObj, "mobilePhone", this.servePersonData.mobilePhone)
      this.$set(this.serverObj, "servePersonID", this.servePersonData.id)
      this.showServeName1Close()
    },
    // 从属服务人员点击保存
    serveNameSend() {
      this.$set(
        this.serverObj,
        "otherservePersonName",
        this.servePersonData.name
      )
      // this.$set(this.serverObj, 'mobilePhone', this.servePersonData.mobilePhone)
      this.$set(this.serverObj, "otherservePersonID", this.servePersonData.id)
      this.showServeNameClose()
    },
    // 服务人员弹框关闭
    showServeName1Close() {
      this.showServeName1 = false
      this.serveName1 = ""
      this.serveName1TableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 从属服务人员弹框关闭
    showServeNameClose() {
      this.showServeName = false
      this.serveName = ""
      this.serveNameTableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 服务人员选择人员
    getServePersonName(val) {
      this.servePersonData = val
    },
    //志愿者
    volunteerSelectionChange(data) {
      this.volunteerTemp = data
    },
    //志愿者表格分页
    volunteerSizeChange(val) {
      this.query.pageSize = val
      this.getVoluteerList()
    },
    volunteerCurrentChange(val) {
      this.query.pageNo = val
      this.getVoluteerList()
    },
    volunteerSend() {
      if (this.volunteerTemp.length > 1) {
        this.$message.error("只能选择一个志愿者")
        return
      }
      this.showVolunteer = false
      if (this.volunteerTemp.length === 1) {
        this.$set(
          this.serverObj,
          "voluteerName",
          this.volunteerTemp[0].userName
        )
      }
    },
    getDataList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          belongAddressLevel: 2,
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.options = res.content
          } else {
            this.options = []
          }
        }
      })
    },
    // 选择客户姓名
    inputClickName() {
      if (this.showTitle === "查看") return
      this.showAddStatus = true
      this.$refs.Customer.getDataList()
    },
    handleAvatarSuccess(res, file) {
      //this.imageUrl = URL.createObjectURL(file.raw)
      this.$set(this.serverObj, "picStart", res.content)
    },
    handleAvatarSuccess1(res, file) {
      //this.imageUrl = URL.createObjectURL(file.raw)
      this.$set(this.serverObj, "picFinished", res.content)
    },
    handleAvatarSuccess2(res, file) {
      this.$set(this.serverObj, "pictureVisit", res.content)
    },
    handleAvatarSuccess3(res, file) {
      if (
        this.serverinfoObj.supplePic == null ||
        this.serverinfoObj.supplePic == ""
      ) {
        this.serverinfoObj.supplePic = []
      }
      let par = res.content
      this.serverinfoObj.supplePic.push(par)
    },
    handleRemove(file) {
      // 1.获取将要删除图片的临时路径
      const filePath = file.url
      // 2.从pics数组中，找到图片对应的索引值
      const i = this.serverinfoObj.supplePic.findIndex((x) => x === filePath)
      // 3.调用splice方法，移除图片信息
      this.serverinfoObj.supplePic.splice(i, 1)
    },
    masterFileMax() {
      if (this.serverinfoObj.supplePic.length >= 5) {
        this.$message.warning(`请最多上传10个文件。`)
        return
      }
    },
    beforeAvatarUpload1() {},
    beforeAvatarUpload(file) {},
    async videohttp(e) {
      if (e.target.files[0].size > 20971520) {
        this.$message.warning("视频文件大小不超过20M")
        return
      }
      const res = await uploadOnlineStudyVideo(e.target.files[0])
      this.$set(this.serverObj, "videoUrl", res.content)
      // this.addForm.videoName = e.target.files[0].name
    },
    async videosuperhttp(e) {
      if (e.target.files[0].size > 20971520) {
        this.$message.warning("视频文件大小不超过20M")
        return
      }
      const res = await uploadOnlineStudyVideo(e.target.files[0])
      this.$set(this.serverinfoObj, "suppleVideo", res.content)
      // this.addForm.videoName = e.target.files[0].name
    },
    // 上传视频
    // handleAvatarSuccess4(res, flie) {
    //     this.serverinfoObj.serverinfoObj = res.content
    //     console.log(this.serverinfoObj.serverinfoObj, res)
    // },
    async audiohttp(e) {
      const res = await uploadOnlineStudyAudio(e.target.files[0])
      this.$set(this.serverObj, "estimateVoiceRecord", res.content)
      // this.addForm.videoName = e.target.files[0].name
    },
    async audiohttpD(e) {
      const res = await uploadOnlineStudyAudio(e.target.files[0])
      this.$set(this.serverObj, "estimateRecord", res.content)
      // this.addForm.videoName = e.target.files[0].name
    },
    async audiohttp1(e) {
      const res = await uploadOnlineStudyAudio(e.target.files[0])
      this.$set(this.serverObj, "recVisit", res.content)
      // this.addForm.videoName = e.target.files[0].name
    },
    async audiohttp2(e) {
      const res = await uploadOnlineStudyAudio(e.target.files[0])
      this.$set(this.serverinfoObj, "suppleRecord", res.content)
      // this.addForm.videoName = e.target.files[0].name
    },
    oldCard() {
      this.showCard = !this.showCard
    },
    otherTelephone(val) {
      this.qtlxfs = val == "1"
    },
    isFranchisee(val) {
      this.franchisee = val === "是"
    },
    isOtherServePerson(val) {
      this.otherServePerson = val === "是"
    },
    isVolunteer(val) {
      this.volunteer = val === "是"
    },
    send() {
      if ((this.showTitle = "工单补录")) {
        if (!this.serverState.states) {
          this.$message.error("请先选择工单状态")
          return
        }
      }
      if (!this.serverObj.customerName) {
        this.$message.error("请先选择客户姓名")
        return
      }
      if (!this.serverObj.customerType) {
        this.$message.error("请先选择工单类型")
        return
      }
      if (!this.serverObj.ensure) {
        this.$message.error("请先选择套餐类型")
        return
      }
      if (!this.serverObj.servestationName) {
        this.$message.error("请先选择机构")
        return
      }
      if (!this.serverObj.servePersonName) {
        this.$message.error("请先选择服务人员")
        return
      }
      if (
        this.serverObj.serveproductName == undefined ||
        this.serverObj.serveproductName == ""
      ) {
        this.serverObj.serveproductName.length = 0
      }
      if (
        this.serverObj.serviceNumber > this.serverObj.serveproductName.length
      ) {
        this.$message.error(
          `请选择大于或等于“${this.serverObj.serviceNumber}”条，服务项目`
        )
        return
      } else {
        this.serverObj.serveproductName =
          this.serverObj.serveproductName.toString()
      }
      var data = this.serverObj
      //  this.serverObj.ensure=this.serverObj.ensureId
      let url = ""
      if (this.serverObj.id == undefined || this.serverObj.id == "undefined") {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        request({
          url: "/jjyl/pgdService/info/save",
          method: "POST",
          data: {
            ...this.serverObj,
            ...this.serverState,
          },
        })
          .then((res) => {
            if (res.code === 200) {
              let row = res.content
              this.$message.success("工单信息保存成功")
              this.callback("编辑", row)
              loading.close()
              this.closeWindow()
            } else {
              loading.close()
            }
          })
          .catch((error) => {
            this.closeWindow()
            loading.close()
          })
      } else {
        //代表编辑
        if (this.serverObj.visitResults == 0) {
          url = "/jjyl/servicePgd/info/Visit"
        } else if (this.serverObj.visitResults == 1) {
          if (
            this.serverObj.visitReason == undefined ||
            this.serverObj.visitReason == ""
          ) {
            this.$message.error("请输入不合格理由")
            return
          }
          url = "/jjyl/servicePgd/info/visitAbnormal"
          data.id = this.serverObj.id
        } else if (
          this.serverObj.visitResults == 2 ||
          this.serverObj.visitResults == 3
        ) {
          if (this.serverObj.visitReason == undefined) {
            this.$message.error("请输入理由")
            return
          }
          url = "/jjyl/servicePgd/info/Invalid"
          data.states = this.serverObj.visitResults == 2 ? "4" : "8"
          // 添加作废理由
          data.visitReason = this.serverObj.visitReason
          data.orderNum = this.serverObj.orderNum
          data.id = this.serverObj.id
          // 添加作废申请人
          data.askCloseName = this.$store.state.info.name
        }
        data.visitstate = this.serverObj.visitResults
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        request({
          url: "/jjyl/pgdService/info/save",
          method: "POST",
          data: {
            ...this.serverObj,
          },
        })
          .then((res) => {
            if (res.code === 200) {
              if (data.visitstate == "2" || data.visitstate == "3") {
                this.getCancle(url, data)
              } else if (data.visitstate == "1") {
                this.getNoPass(url, data)
              } else {
                this.$message.success(res.message)
                this.handleClose()
              }
              loading.close()
            } else {
              loading.close()
            }
          })
          .catch((error) => {
            loading.close()
          })

        this.getInfoMsg(data)
        this.getDataList()
        this.closeWindow()
        this.$emit("updateList")
      }
    },
    getInfoMsg(data) {
      if (this.serverinfoObj.supplePic) {
        this.serverinfoObj.supplePic = this.serverinfoObj.supplePic.join(",")
      }
      request({
        url: "/jjyl/servicePgdSupple/info/save",
        method: "POST",
        data: {
          servicePgdId: data.id,
          id: this.infoId,
          supplePic: this.serverinfoObj.supplePic,
          suppleVideo: this.serverinfoObj.suppleVideo,
          suppleRecord: this.serverinfoObj.suppleRecord,
        },
      }).then((res) => {
        if (res.code === 200) {
        }
      })
    },
    // 作废 虚拟工单
    getCancle(url, parmar) {
      const self = this
      request({
        url: url,
        method: "POST",
        data: parmar,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.handleClose()
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //不合格
    getNoPass(url, parmar) {
      const self = this
      request({
        url: url,
        method: "POST",
        data: parmar,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.handleClose()
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //派发
    payOut() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          delete this.serverObj.franchisee
          delete this.serverObj.otherServePerson
          delete this.serverObj.volunteer
          if (this.serverObj.servePersonID) {
            request({
              url: "/jjyl/servicePgd/info/insertAndDistribute",
              method: "POST",
              data: {
                ...this.serverObj,

                // otherservePersonID: null,
                // serveStation: null,
                states: 1,
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$message.success("派发成功")
                this.$emit("updateList")
              } else {
                this.$message.success("派发失败")
              }
            })
          } else {
            // delete this.serverObj.servePersonName
            // delete this.serverObj.mobilePhone
            // delete this.serverObj.servePersonID
            // this.$message.error('请选择服务人员')
            // return
            request({
              url: "/jjyl/servicePgd/info/Distribute",
              method: "POST",
              data: {
                ...this.serverObj,
                states: 1,
                id: this.serverObj.id,
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$message.success("派发成功")
                this.$emit("updateList")
              } else {
                this.$message.success("派发失败")
              }
            })
          }
        } else {
          this.$message.error("请按照规则输入")
          return false
        }
      })
    },
    //派发
    sendMsg() {
      this.display = 0
    },
    //处理
    disposeMsg() {
      this.display = 1
    },
    //回访
    callbackMag() {
      this.display = 2
    },
    //回访中
    callbackingMag() {
      this.display = 3
    },
    //补充资料
    InfoMag() {
      this.display = 4
    },
    // 回访弹框关闭
    handleClose() {
      this.display = 0
      this.dialogVisible = false
      this.serverObj = {}
      this.$refs.clearPaths && this.$refs.clearPaths.reset()
      if (this.$refs.CallbackVisitDialog) {
        this.$refs.CallbackVisitDialog.changeContent = []
      }
    },
    closeWindow() {
      this.$emit("update:showVisit", false)
      this.display = 0
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      this.$refs.form && this.$refs.form.resetFields()
      this.$refs.form.clearValidate()
      this.$refs.clearPaths && this.$refs.clearPaths.reset()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.$refs.clearPaths && this.$refs.clearPaths.reset()
      })
      this.$refs.CallbackVisitDialog.$refs.ruleForm.resetFields()
      this.serverObj = {}
      this.serverState = {}
      this.serverinfoObj = {}
      this.serveproductName = []
      this.qtlxfs = false
      this.franchisee = false
      this.otherServePerson = false
      this.volunteer = false
      // 套餐类型应当选择的服务数量为0
      this.serviceNumber = 0
    },
    //不合格事件
    disqualificationFun(data) {
      this.btnActive = data !== "不合格"
    },
    //处理中打电话时间
    callPhone1(phone, type) {
      if (phone == null || phone == "") {
        this.$message.warning("号码无效，暂无法拨号")
      } else {
        this.$store.dispatch("setPhone", phone)
        exportVue.$emit("question", true)
        setTimeout(() => {
          this.callType(phone, type, 1)
        }, 5000)
      }
    },
    //回访中打电话时间
    callPhone2(phone, type) {
      if (phone == null || phone == "") {
        this.$message.warning("号码无效，暂无法拨号")
      } else {
        this.$store.dispatch("setPhone", phone)
        exportVue.$emit("question", true)
        setTimeout(() => {
          this.callType(phone, type, 2)
        }, 5000)
      }
    },
    // 拨号处理
    callType(phone, type, state) {
      const self = this
      request({
        url: "/jjyl/traffic/callInfo/info/saveCallIdforNormalPdg",
        method: "POST",
        data: {
          remoteNum: phone,
          agentID: self.$store.state.seatNo,
          servicepgdId: self.serverObj.id,
          callToType: type,
          states: state,
        },
      }).then((res) => {})
    },
  },
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.add-ent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.add-ent > div {
  width: 48%;
}

.add-title1 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.add-title1 > div:first-child {
  width: 120px;
  text-align: right;
}

.add-title1 > div:nth-child(2) {
  width: calc(100% - 120px);
}

.visit-image {
  width: 60%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.image-title {
  width: 178px;
  margin-top: 10px;
  text-align: center;
}
.audiofile {
  margin-left: 20%;
  margin-bottom: 15px;
}
.cu-title1 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.cu-title1 > div {
  width: 50%;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.audioActive {
  margin-left: 180px;
  margin-bottom: 20px;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
</style>
<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.dialogBtns {
  display: flex;
  justify-content: center;
  margin: 15px 0;

  .el-button {
    margin-right: 40px;
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #999;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  img {
    width: 100%;
    height: 100%;
  }
}

.imgBox {
  height: 200px;
  width: 150px;

  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    margin-bottom: 10px;
    width: 100px;
    height: 100px;
  }

  div {
    width: 70%;
    background-color: #169bd5;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.workstart {
  text-align: center;
  background: #169bd5;
  color: #fff;
  margin-top: 15px;
  width: 86%;
}
.audios {
  margin: 10px 0;
}
</style>
